import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'atn-datagrid',
  templateUrl: './datagrid.component.html',
  styleUrls: ['./datagrid.component.scss']
})
export class DatagridComponent implements OnInit {
  @Input() name: string;
  @Input() columns: Array<Object> = [];
  @Input() data: Array<Object> = [];

  filters: Array<any> = [];

  ngOnInit() {}

  filter(field: string, value: any, resolver: Function) {
    let filter = this.filters.find(f => f.field == field);

    if (filter === undefined) {
      this.filters.push({
        field: field,
        value: value
      });
    } else {
      filter.value = value;
    }
  }
}


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/datagrid/datagrid.component.ts